import { atom } from 'recoil'

import { THEME_ATOM } from 'atoms/keys'

export const themeAtom = atom({
  key: THEME_ATOM,
  default: false,
})
